import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);
// import Swiper styles
import 'swiper/css';

$(document).ready(function() {
  initSmallSwiper();
});

$( window ).resize(function() {
  initSmallSwiper();  
});


function initSmallSwiper() {
  
  let width = $( window ).width();
  let swiperEnabled = false;
  let smallSwiper;

  if( width <= 810) {

    if( !swiperEnabled ) {

      smallSwiper = new Swiper('.smallswiper-container', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        centeredSlides: true,
      
        // Navigation arrows
        navigation: {
          nextEl: ".smallswiper-prev",
          prevEl: ".smallswiper-next",
        },
      
      });

      swiperEnabled = ( swiperEnabled == false ? true : false );
    }
  }
  else {
    swiperEnabled = false;
  }
}